import { ErrorHandler, Injectable } from '@angular/core';
import * as StackTrace from 'stacktrace-js';

import { LoggerService } from 'app/services/logger.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private logger: LoggerService) {}

  private lastMessage: string = undefined;

  handleError(error) {
    const message = error.message || String(error);

    if (!this.isLoggable(message)) {
      return;
    }

    if (error.message) {
      StackTrace.fromError(error)
        .then((stack) => {
          this.logger.error('UnhandledException', {
            message,
            location: stack[0],
          });
        })
        .catch(() => {
          this.logger.error('UnhandledException', {
            response: error.error,
          });
        });
    } else {
      this.logger.error('UnhandledException', {
        message,
      });
    }
  }

  isLoggable(message: string): boolean {
    if (!message || message === this.lastMessage) {
      return false;
    }
    this.lastMessage = message;
    return true;
  }
}
